import React, { useEffect, useState } from "react";
import { ConfigProvider, App as AntdApp, theme, Watermark } from "antd";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import UsersRoutes from "./Routes/UsersRoutes";
import AdminRoutes from "./Routes/AdminRoutes";
import { getUser } from "./authService";

import Login from "./User-panel/pages/login/Login";
import CulsightPageLoader from "./User-panel/components/CulsightPageLoader";
import TermsAndPolicies from "./User-panel/pages/login/TermsAndPolicies";
import MicrosoftCallback from "./User-panel/pages/login/MicrosoftCallback";
import NotFound from "./User-panel/pages/NotFound";

function App() {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null); // "sub_admin" | "learner"
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [blackTheme, setBlackTheme] = useState("dark");
  const [switchPortal, setSwitchPortal] = useState(false);

  // ✅ Load Theme From localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem("dark_theme");
    if (savedTheme) {
      setBlackTheme(savedTheme);
    } else {
      localStorage.setItem("dark_theme", "dark");
    }
  }, []);

  // ✅ Authentication Check
  useEffect(() => {
    const checkUserAuth = async () => {
      try {
        setCheckingAuth(true);

        const u = await getUser();

        if (u?.user_info) {
          setUser(u);
          if (localStorage.getItem("current_switch") === "admin") {
            setUserRole("admin");
          } else if (localStorage.getItem("current_switch") === "learner") {
            setUserRole("learner");
          } else {
            const roles = u.user_info.roles || [];
            const switchStatus = Boolean(u.user_info.switch);

            setSwitchPortal(switchStatus);

            // 🔥 FIXED ROLE LOGIC
            if (roles.includes("sub_admin")) {
              setUserRole("sub_admin");
              switchStatus && localStorage.setItem("current_switch", "admin")
              localStorage.setItem("user_role", "sub_admin");
            } else {
              setUserRole("learner");
            }
          }

        }

      } catch (error) {
        console.error("Auth Error:", error);
        setUser(null);
        setUserRole(null);
      } finally {
        setCheckingAuth(false);
      }
    };

    checkUserAuth();
  }, []);

  // ✅ Loader Until Auth Ready
  if (checkingAuth) return <CulsightPageLoader />;

  return (

    <ConfigProvider
      theme={{
        algorithm:
          blackTheme === "dark"
            // ? theme.darkAlgorithm
            // : theme.defaultAlgorithm,
            ? theme.defaultAlgorithm
            : theme.defaultAlgorithm,
        
      }}
    >
      <AntdApp>
       
          <Routes>
            {user ? (
              <Route
                path="/*"
                element={
                  userRole === "admin" ? (
                    <AdminRoutes
                      black_theme={blackTheme}
                      set_black_theme={setBlackTheme}
                      switch_portal={switchPortal}
                      set_Switch_portal={setSwitchPortal}
                    />
                  ) :
                    userRole === "learner" ? (
                      <UsersRoutes
                        black_theme={blackTheme}
                        set_black_theme={setBlackTheme}
                        switch_portal={switchPortal}
                        set_Switch_portal={setSwitchPortal}
                      />
                    ) : (
                      <CulsightPageLoader />
                    )
                }
              />
            ) : (
              <>
                <Route path="/" element={<Login />} />
                <Route
                  path="/microsoft-callback"
                  element={<MicrosoftCallback />}
                />
                <Route
                  path="/terms-policy"
                  element={<TermsAndPolicies />}
                />
                <Route path="*" element={<Navigate to="/" />} />
              </>
            )}
          </Routes>
       
      </AntdApp>
    </ConfigProvider>

  );
}

export default App;